// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"e1d33e20","345":"98c611b3","825":"44be3012","855":"112da85d","960":"6ae5ac21"}[chunkId] + ".chunk.js";
};